// Gulf (main) funnel shared constants — mirrors egConstants.js but
// without the EG-only price and with the Gulf nav paths (no /eg prefix).
// Reuses the same hero video MP4 unless the user provides a Gulf-specific one.

export const GULF_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_charisma-protocol/artifacts/je0cj2wk_lv_0_20260529124413.mp4";

export const GULF_VIDEO_LABEL = "gulf-sample-video";

export const GULF_PREVIEW_PAGES = [
  "/preview/P1.png",
  "/preview/P2.png",
  "/preview/P3.png",
  "/preview/P4.png",
];

export const GULF_NAV = [
  { to: "/about", label: "ما هو الكتاب الأزرق", testid: "nav-gulf-about" },
  { to: "/sample", label: "عينة من الكتاب", testid: "nav-gulf-sample" },
  { to: "/community", label: "انضم لمجتمعنا", testid: "nav-gulf-community" },
  { to: "/refund", label: "سياسة الاسترجاع", testid: "nav-gulf-refund" },
  { to: "/contact", label: "للتواصل", testid: "nav-gulf-contact" },
];
